import React from "react";

import { useSelector } from "react-redux";
import { views } from "../utils";

export default function AllTouroperatorsFilter(props) {
  const { changeFilterAndSearch } = props;
  const searchtourOperators = useSelector(
    (state) => state.search.tourOperators
  );

  const [showAll, setShowAll] = React.useState(false);

  const loading = useSelector((state) => state.system.loading);
  const view = useSelector((state) => state.system.view);

  const optionOperators = useSelector((state) => state.filter.optionOperators);
  const tourOperators = useSelector((state) => state.filter.tourOperators);
  const alltourOperators = useSelector(
    (state) => state.properties.tourOperators
  );

  const hotelTourOperators = useSelector(
    (state) => state.filter.hotelTourOperators
  );

  let to =
    view === views.offerview ? [...tourOperators] : [...hotelTourOperators];

  for (let i = 0; i < searchtourOperators.length; i++) {
    let found = false;
    for (let j = 0; j < to.length; j++) {
      if (searchtourOperators[i] === to[j].TourOperatorCode) {
        found = true;
        break;
      }
    }
    if (!found) {
      to.push(
        alltourOperators.find(
          (e) => e.TourOperatorCode === searchtourOperators[i]
        )
      );
    }
  }

  if (Array.isArray(to) && to.length > 0 && !to[0]) {
    return <></>;
  }

  let ct = 0;

  return (
    <div className="alltouroperatorsfilter">
      <span className="alltouroperatorsfilter1 filterheader">Veranstalter</span>
      {/*
      <div style={{ marginTop: 16, marginBottom: 16 }}><span style={{ color: "white", padding: 8, backgroundColor: "orange", cursor: "pointer" }} onClick={() => {
        let changed = [];
        //console.log(optionOperators);
        for (let i = 0; i < optionOperators.length; i++) {
          if (alltourOperators.find(
            (e) => e.TourOperatorCode === optionOperators[i].touroperator
          )) {
            changed.push(optionOperators[i].touroperator);
          }
          else {
            console.log(optionOperators[i]);
          }
        }
        changeFilterAndSearch("tourOperators", changed);
      }
      }>Veranstalter mit Option</span></div>*/}
      {
        to.sort((a, b) => ("" + a.TourOperatorName).localeCompare(b.TourOperatorName)).map((itm) => {
          ct = ct + 1;
          if (ct > 5 && !showAll) return null;
          
          let disabled = false;
          if (loading > 0) disabled = true;
          return (
            <div className="filterrow" key={itm.TourOperatorCode}>
              <div className="filter1">
                <input
                  className="alltouroperatorsfilter4"
                  checked={searchtourOperators.includes(itm.TourOperatorCode)}
                  onChange={() => {
                    let changed = [...searchtourOperators];
                    if (changed.includes(itm.TourOperatorCode)) {
                      changed = changed.filter((e) => e !== itm.TourOperatorCode);
                    } else {
                      changed.push(itm.TourOperatorCode);
                    }
                    changeFilterAndSearch("tourOperators", changed);
                  }}
                  disabled={disabled}
                  type="checkbox"
                />
              </div>
              <div className="filter2">
                <div className="filtertext"                   dangerouslySetInnerHTML={{
                    __html: "" + itm.TourOperatorName,
                  }}>
                </div>
              </div>
            </div>
          );
        })
      }
      {!showAll && ct > 5 && <div style={{ cursor: "pointer" }} onClick={() => setShowAll(true)}>alle anzeigen</div>}
      {showAll && <div style={{ cursor: "pointer" }} onClick={() => setShowAll(false)}>weniger anzeigen</div>}
    </div >
  );
}
